<script setup>
import Spinner from "@/Components/Icons/Spinner.vue";

const props = defineProps({
  onShowMore: Function,
  hasMore: Boolean,
  loading: Boolean,
});
</script>

<template>
  <div class="flex flex-col justify-center">
    <slot></slot>
    <div class="mt-2">
      <button v-if="hasMore"
              :disabled="loading"
              class="flex items-center justify-center gap-2 bg-slate-200 dark:bg-slate-800 hover:bg-slate-300 dark:hover:bg-slate-700 disabled:hover:bg-slate-200 dark:disabled:hover:bg-slate-800 disabled:opacity-60 disabled:cursor-wait transition-colors text-black dark:text-slate-200 font-sans text-sm font-medium px-4 py-2 rounded-md w-full"
              @click="onShowMore">
        <Spinner v-if="loading" class="mr-0"/>
        {{ $t('Show more') }}
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>
